import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LeftRightNavigationButtonsProps {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
  prevButtonClassName?: string;
  nextButtonClassName?: string;
}

const LeftRightNavigationButtons: React.FC<LeftRightNavigationButtonsProps> = ({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  className = '',
  prevButtonClassName = '',
  nextButtonClassName = '',
}) => {
  return (
    <div
      className={twMerge(
        `flex justify-center items-center md:justify-self-end md:self-end md:b-0`,
        className
      )}
    >
      <button
        className={twMerge(
          `rounded-s-full px-4 py-2 text-xl ${
            hasPrev ? 'bg-primary text-white' : 'bg-gray-100 text-gray-300'
          }`,
          prevButtonClassName
        )}
        onClick={onPrev}
        disabled={!hasPrev}
      >
        &lt;
      </button>
      <button
        className={twMerge(
          `rounded-e-full px-4 py-2 text-xl ${
            hasNext ? 'bg-primary text-white' : 'bg-gray-100 text-gray-300'
          }`,
          nextButtonClassName
        )}
        onClick={onNext}
        disabled={!hasNext}
      >
        &gt;
      </button>
    </div>
  );
};

export default LeftRightNavigationButtons;
